// Create a copy of the StreamrVideoFrame to make it safe to transfer
// the EncodedVideoFrame to the workers
export function streamrVideoFrameToEncodedVideoFrame(streamrVideoFrame) {
    return {
        frameNumber: streamrVideoFrame.frameNumber,
        timestamp: streamrVideoFrame.timestamp,
        duration: streamrVideoFrame.duration,
        isKeyFrame: streamrVideoFrame.isKeyFrame,
        data: new Uint8Array(streamrVideoFrame.data),
        extradata: new Uint8Array(streamrVideoFrame.extradata),
        codedWidth: streamrVideoFrame.codedWidth,
        codedHeight: streamrVideoFrame.codedHeight,
        codec: streamrVideoFrame.codec,
        isScreenSharing: streamrVideoFrame.isScreenSharing,
        rotation: streamrVideoFrame.rotation,
        trackId: streamrVideoFrame.trackId,
        done: streamrVideoFrame.done,
    };
}
export function streamrVideoFrameToInboundEncodedVideoFrame(streamrVideoFrame, userSessionId) {
    return {
        ...streamrVideoFrameToEncodedVideoFrame(streamrVideoFrame),
        userSessionId,
    };
}
export function encodedVideoFrameToVideoFrame(encodedVideoFrame) {
    return encodedVideoFrame;
}
export function createDoneEncodedVideoFrame(trackId, frameNumber) {
    return {
        frameNumber: frameNumber,
        timestamp: 0n,
        duration: 0n,
        trackId: trackId,
        done: true,
        isKeyFrame: true, // Treat done frames as keyframes so JitterBuffer skip logic processes them
        data: new Uint8Array(),
        extradata: new Uint8Array(),
        codedWidth: 0,
        codedHeight: 0,
        codec: '',
        isScreenSharing: false,
        rotation: 0,
    };
}
